import { TAB_ROUTES } from '../../config/routes';

export const isTabRoute = (route) => TAB_ROUTES.some((tabRoute) => route.includes(tabRoute));
